import {useQuery} from '@github-ui/react-query'
import {verifiedFetchJSON} from '@github-ui/verified-fetch'

import {reposPickerRepositoriesPath} from '../paths'
import type {FetchRepositoriesData, PickerScope} from '../types'

export function useQueryRepositories({
  scope,
  enabled = true,
  query = '',
}: {
  scope: PickerScope
  enabled?: boolean
  query?: string
}) {
  return useQuery<FetchRepositoriesData>({
    queryKey: ['repos-picker', 'repositories', scope, query],
    queryFn: async () => {
      const fetchRepositoriesUrl = reposPickerRepositoriesPath({scope, query})

      const response = await verifiedFetchJSON(fetchRepositoriesUrl)
      if (!response.ok) {
        throw new Error('Error fetching repositories')
      } else {
        return await response.json()
      }
    },
    enabled,
  })
}
